module.exports = __webpack_public_path__ + "static/img/info_button1.36b0855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button1.png
// module id = wFVB
// module chunks = 4